
export default [
  {
    path:'agents',
    name:'agents',
    meta:{
      name: "代理商管理",
      power: "agent",
      title:'代理商管理-Co-logistics'
    },
    component: () => import("@/view/business/agents.vue"),
  },
  {
    path:'store',
    name:'store',
    meta:{
      name: "代理仓库管理",
      power: "house",
      title:'代理仓库管理-Co-logistics'
    },
    component: () => import("@/view/business/store.vue"),
  },
  {
    path:'ocean',
    name:'ocean',
    meta:{
      name: "专线价格管理",
      power: "seaus",
      title:'专线价格管理-Co-logistics'
    },
    component: () => import("@/view/userlist/shops/index.vue"),
  },

  // {
  //   path:'europe',
  //   name:'europe',
  //   meta:{
  //     name: "欧洲海派价格管理",
  //     power: "seaeurope",
  //     title:'欧洲海派价格管理-Co-logistics'
  //   },
  //   component: () => import("@/view/business/europe.vue"),
  // },
  // {
  //   path:'canda',
  //   name:'canda',
  //   meta:{
  //     name: "加拿大价格管理",
  //     power: "seaca",
  //     title:'加拿大价格管理-Co-logistics'
  //   },
  //   component: () => import("@/view/business/canda.vue"),
  // },
  // {
  //   path:'usaair',
  //   name:'usaair',
  //   meta:{
  //     name: "美国空派价格管理",
  //     power: "airus",
  //     title:'美国空派价格管理-Co-logistics'
  //   },
  //   component: () => import("@/view/business/usaair.vue"),
  // },
  // {
  //   path:'europerail',
  //   name:'europerail',
  //   meta:{
  //     name: "欧洲铁派价格管理",
  //     power: "ironeurope",
  //     title:'欧洲铁派价格管理-Co-logistics'
  //   },
  //   component: () => import("@/view/business/cerail.vue"),
  // },
  // {
  //   path:'expressprice',
  //   name:'expressprice',
  //   meta:{
  //     name: "快递价格管理",
  //     power: "addexpress",
  //     title:'快递价格管理-Co-logistics'
  //   },
  //   component: () => import("@/view/business/express/index.vue"),
  // },
  {
    path:'cabinet',
    name:'cabinet',
    meta:{
      name: "海运整柜价格",
      power: "seabox",
      title:'海运整柜价格-Co-logistics'
    },
    component: () => import("@/view/business/cabinet.vue"),
  },
  {
    path:'pricetable',
    name:'pricetable',
    meta:{
      name: "海派价格表",
      power: "price_excel",
      title:'海派价格表-Co-logistics'
    },
    component: () => import("@/view/business/priceTable/index.vue"),
  },
  {
    path:'shipcompany',
    name:'shipcompany',
    meta:{
      name: "船司船名管理",
      power: "ship",
      title:'船司船名管理-Co-logistics'
    },
    component: () => import("@/view/business/ship-company/index.vue"),
  },
  {
    path:'labelcategory',
    name:'labelcategory',
    meta:{
      name: "标签集管理",
      power: "transport_tags",
      title:'标签集管理-Co-logistics'
    },
    component: () => import("@/view/business/label-category/index.vue"),
  },
  {
    path:'categories',
    name:'categories',
    meta:{
      name: "类目管理",
      power: "categories",
      title:'类目管理-Co-logistics'
    },
    component: () => import("@/view/business/category-management/index.vue"),
  },
  // {
  //   path:'proname',
  //   name:'proname',
  //   meta:{
  //     name: "品名池管理",
  //     power: "pool",
  //     title:'品类管理-Co-logistics'
  //   },
  //   component: () => import("@/view/business/proname.vue"),
  // },
  {
    path:'country',
    name:'country',
    meta:{
      name: "运输国家管理",
      power: "country",
      title:'运输国家管理-Co-logistics'
    },
    component: () => import("@/view/business/country.vue"),
  },
  
  {
    path:'fbacode',
    name:'fbacode',
    meta:{
      name: "亚马逊仓库地址管理",
      power: "fbahouse",
      title:'亚马逊地址管理-Co-logistics'
    },
    component: () => import("@/view/business/fbacode.vue"),
  },
  {
    path:'product',
    name:'product',
    meta:{
      name: "客户端管理",
      power: "customer",
      title:'品名管理-Co-logistics',
      noShow: true
    },
    component: () => import("@/view/business/productname.vue"),
  },
]